/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalendarCount } from '../models/CalendarCount';
import type { CalendarEventType } from '../models/CalendarEventType';
import type { FullPatientCalendar } from '../models/FullPatientCalendar';
import type { FullPatientCalendarEvents } from '../models/FullPatientCalendarEvents';
import { request as __request } from '../core/request';

export class PatientCalendarService {

    /**
     * Get company patient calendar events
     * @returns FullPatientCalendarEvents Patient Calendar Events
     * @throws ApiError
     */
    public static async getPatientCalendarEvents({
companyId,
beginAt,
endAt,
}: {
/** The companyId **/
companyId: number,
beginAt?: string,
endAt?: string,
}): Promise<FullPatientCalendarEvents> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/patient-calendar`,
            query: {
                'beginAt': beginAt,
                'endAt': endAt,
            },
        });
        return result.body;
    }

    /**
     * add a patient calendar event
     * @returns FullPatientCalendar patient calendar event updated
     * @throws ApiError
     */
    public static async addPatientCalendarEvent({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: FullPatientCalendar,
}): Promise<FullPatientCalendar> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/patient-calendar`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update a patient calendar event
     * @returns FullPatientCalendar patient calendar event updated
     * @throws ApiError
     */
    public static async updatePatientCalendarEvent({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: FullPatientCalendar,
}): Promise<FullPatientCalendar> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/patient-calendar`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * delete a patient calendar event
     * @returns FullPatientCalendar event type deleted
     * @throws ApiError
     */
    public static async deletePatientCalendarEvent({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: FullPatientCalendar,
}): Promise<FullPatientCalendar> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/patient-calendar`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Get company patient calendar event types
     * @returns CalendarEventType Patient Calendar Events Types
     * @throws ApiError
     */
    public static async getPatientCalendarEventsTypes({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<CalendarEventType> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/patient-calendar/events`,
        });
        return result.body;
    }

    /**
     * Get company patient calendar events count of the day
     * @returns CalendarCount Company Patient Calendar Events
     * @throws ApiError
     */
    public static async getCalendarEventCount({
companyId,
date,
}: {
/** The companyId **/
companyId: number,
date: string,
}): Promise<CalendarCount> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/patient-calendar/count`,
            query: {
                'date': date,
            },
        });
        return result.body;
    }

}